import React, { useState, Fragment } from 'react'

import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import TimeInput from 'react-time-input'
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog'
import brandTheme from '../../../Assets/Styles/brandTheme'
import { useFormChildLogic } from '../index'

const { colors } = brandTheme()

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    background: colors.primary,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    fontSize: 32,
    color: '#fff',
    background: 'transparent',
    border: 'none',
    width: 90,
  },
  previewBlock: {
    position: 'relative',
    width: '100%',
    borderRadius: 4,
    height: 52,
    background: 'hsl(0, 0%, 97%)',
    border: 'none',
    padding: '0 20px',
    color: 'hsl(219, 37%, 24%)',
    fontSize: 16,
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
  },
})

const ConfirmableTimePicker = props => {
  const { name, initValue } = props
  const [dialogIsOpen, setDialogIsOpen] = useState(false)
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState(props.value)

  const { updateForm } = useFormChildLogic({
    name: name,
    initValue: initValue,
  })
  const _handleOpenPicker = () => {
    setOpen(true)
  }

  const _handlePickerClose = () => {
    setOpen(false)
  }

  const _handlePickerAgree = async () => {
    _confirmationShowDialog()
    _handlePickerClose()
  }

  const _handleUserInput = value => {
    setValue(value)
  }

  const _confirmationShowDialog = async () => {
    setDialogIsOpen(true)
  }

  const _confirmationOnAgree = () => {
    props.onChange ? props.onChange(value) : updateForm(value)
    setValue(value)

    _confirmationOnClose()
  }

  const _confirmationOnDisagree = () => {
    setValue(null)
    _confirmationOnClose()
  }

  const _confirmationOnClose = () => {
    setDialogIsOpen(false)
  }

  const { pickerName, dialogTitle, dialogText, classes } = props

  return (
    <Fragment>
      <div className={classes.previewBlock} onClick={_handleOpenPicker}>
        <span>{value || '--:--'}</span>
      </div>
      <Dialog
        disableEnforceFocus={true}
        open={open}
        onClose={_handlePickerClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent className={classes.container}>
          <TimeInput
            initTime={value}
            className={classes.textField}
            onTimeChange={_handleUserInput}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={_handlePickerClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={_handlePickerAgree}
            disabled={!value}
            color="primary"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmDialog
        isOpen={dialogIsOpen}
        title={dialogTitle}
        contentText={dialogText || `You will set ${pickerName} to ${value}?`}
        onAgree={_confirmationOnAgree}
        onDisagree={_confirmationOnDisagree}
      />
    </Fragment>
  )
}

export default withStyles(styles)(ConfirmableTimePicker)



// WEBPACK FOOTER //
// ./src/Components/Form/ConfirmableTimePicker/index.js